// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-solid[data-v-058d0093]{color:#969696}.avatar[data-v-058d0093]{display:flex;flex-direction:row;align-items:center;justify-content:center;background-color:transparent;width:100%;height:100%;border-radius:50%}.avatar-dummy[data-v-058d0093]{background-color:#d7f3ff}", ""]);
// Exports
module.exports = exports;
